export default __webpack_public_path__ + "static/howto-home1-60006323f2b927c8051904fe2d79ae8b.svg";